import { IMG_TYPES, SUPPORTED_LOCALES } from '@repo/config';
import { z } from 'zod';

export const deleteImgRequestSchema = z.object({
  type: z.enum(IMG_TYPES),
  slug: z.string().min(1),
  locale: z.enum(SUPPORTED_LOCALES).optional(),
});

export type IDeleteImgRequest = z.infer<typeof deleteImgRequestSchema>;
